<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Lyndsay Purdie, thanks for your help during the early stages of <em>Apok</em>. Catherine Dunn, for your outstanding skill, incredible feedback and making me believe I can do it. Carol, my biggest fan. I’m just so glad you liked the story. Sarah, for always asking about the story I was writing. Your enthusiasm and belief was invaluable.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?e9452b52